export default __webpack_public_path__ + "static/media/babymilestoneImg3.cff7ca96.png";